export type ChatwootAccessMode = 'internal' | 'customer';

export type ChatwootModule = 'uops' | 'ucontrol' | 'cockpit' | 'book';

export type ChatwootEntityType = 'order' | 'shipment' | 'support_request' | 'exception' | 'inventory' | 'dashboard';

export interface ChatwootRouteData {
    module?: ChatwootModule; // optional — URL heuristic provides fallback
    pageType: string;
    entityType?: ChatwootEntityType;
    entityIdParam?: string;
}

export interface ChatwootContext {
    source_system: 'logivice';
    organisation_id: number | null;
    organisation_slug: string | null;
    partner_id: number | null;
    partner_slug: string | null;
    partner_name: string | null;
    module: ChatwootModule | null;
    page_type: string | null;
    entity_type: ChatwootEntityType | null;
    entity_id: string | null;
    entity_reference: string | null;
    current_route: string;
    user_role: string | null;
    access_mode: ChatwootAccessMode;
    initiated_from: 'logivice_widget';
}

export const CHATWOOT_CONTACT_LEVEL_KEYS = [
    'source_system',
    'organisation_id',
    'organisation_slug',
    'user_role',
    'access_mode'
] as const satisfies readonly (keyof ChatwootContext)[];

export type ChatwootContactLevelKey = (typeof CHATWOOT_CONTACT_LEVEL_KEYS)[number];
